var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('aside',{ref:"drawer",staticClass:"drawer drawer--modal"},[_vm._t("default",null,{"closeDrawer":_vm.close,"close":_vm.close})],2),_c('div',{ref:"scrim",staticClass:"scrim",on:{"click":_vm.close}})])}
var staticRenderFns = []

export { render, staticRenderFns }